<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-12-08 14:25:33
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-12-08 15:11:05
 * @FilePath: \合联\oms\src\view\analysis\adjustBillRecord\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/adjustBillRecord";
export default {
  name: "adjustBillRecord",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        detail: {
          config: {
            title: this.$tz("明细"),
            modalBind: {
              width: 1000
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz("账单号"),
                key: "bill_number",
                minWidth: 130
              },
              {
                name: () => this.$tz("账单,金额"),
                key: "bill_amount",
                minWidth: 130
              },
              {
                name: () => this.$tz("账单,币种"),
                key: "bill_amount_currency",
                minWidth: 130
              },
              {
                name: () => this.$tz("部分,核销,金额"),
                key: "part_off_amount",
                minWidth: 130
              },
              {
                name: () => this.$tz("部分,核销,金额,币种"),
                key: "part_off_amount_currency",
                minWidth: 130
              },
              {
                name: () => this.$tz("账单,类型"),
                key: "bill_data_type",
                minWidth: 130
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [],
          methods: {}
        }
      },
      fields: [
        // {
        //   name: () => this.$tz("类型"),
        //   key: "target_type",
        //   minWidth: 130
        // },
        {
          name: () => this.$tz("客户,代码"),
          key: "account",
          minWidth: 130
        },
        {
          name: () => this.$tz("公司中文名"),
          key: "shipper_company_cn",
          minWidth: 130
        },
        {
          name: () => this.$tz("所属公司"),
          key: "ownership_name",
          minWidth: 130
        },
        {
          name: () => this.$tz("账单,金额"),
          key: "before_amount",
          minWidth: 130
        },
        {
          name: () => this.$tz("账单,币种"),
          key: "before_amount_currency",
          minWidth: 130
        },
        {
          name: () => this.$tz("调账,金额"),
          key: "change_amount",
          minWidth: 130
        },
        {
          name: () => this.$tz("实际,核销"),
          key: "after_amount",
          minWidth: 130
        },

        {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("操作人"),
          key: "operator_name",
          minWidth: 130
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 130
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("明细"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              },
              id: ""
            },
            {
              name: () => this.$tz("附件"),
              type: "file",
              fnName: "file",
              bind: {
                type: "primary"
              },
              disabled: ({ row }) => !row.src
            }
          ],
          methods: {
            file({ row }) {
              this.openUrl(row.src);
            },
            detail({ row }) {
              this.handleRequestMethods(
                "detail",
                { id: row.id },
                false,
                true
              ).then(res => {
                this.getModal("detail").open({}, function() {
                  this.setTitle(this.$tz("明细"));
                  this.list = res.payload;
                });
              });
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
